/* jshint node:true */
'use strict';

var React = require('react');

/* Components */
var LeagueTable         = require('./LeagueTable.jsx');
var PlayerList          = require('./PlayerList.jsx');
var NewsList            = require('./NewsList.jsx');
var Advert = require('../../common/Advert.jsx');
var AdReloaderMixin = require('../../../mixins/AdReloaderMixin.js');

var TabLineup = React.createClass({

    displayName: 'TabLineup',

    mixins : [ AdReloaderMixin ],

    getInitialState : function(){
        return {
            adWrapSelector : '#reactContainer .react-ad'
        };
    },

    render: function () {

        var sState      = this.props.matchState || 'pre'; //pre,pos,live
        var oStore      = this.props.store;
        var iWidth      = this.props.width;

        /* Load in the data from the Store */
        var aHomeTeam       = oStore.getPlayersList('home');
        var aAwayTeam       = oStore.getPlayersList('away');
        var aLeagueTable    = oStore.getLeagueTable();
        var leagueName      = oStore.getLeagueName();
        var newsList        = oStore.getNewsList();
        var oHomeTeam       = oStore.getHomeTeam();
        var oAwayTeam       = oStore.getAwayTeam();

        return (
            <div className="layout-bc">
                <section className="col-b">
                    <PlayerList homeTeam={aHomeTeam} awayTeam={aAwayTeam} split={true} matchState={sState} home={oHomeTeam} away={oAwayTeam} width={iWidth}/>
                </section>
                <section className="col-c">
                    <article className="ad-300">
                        <div className="ad-center">
                            <Advert id='game.rhs.mpu' className="ad-slot-incontent ad-wrapper" slotType="incontent" />
                        </div>
                    </article>
                    <LeagueTable tableHref={this.props.tableHref} name={leagueName} table={aLeagueTable} />
                    <NewsList header={newsList.header} link={newsList.link} articles={newsList.articles} />
                </section>
            </div>
        );
    }
});

module.exports = TabLineup;






/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/TabLineup.jsx
 **/